import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { FeeCards, FeePayments, PayPanel, Rules, Schedule, Statement } from "../../components/admin/SagFeeParts";

// SAG Processing Fees: what CIArb owes Sebastian Alliance Group (the gateway reseller) at the agreed rate.
export default function SagFees() {
  const [d, setD] = useState(null);
  const [period, setPeriod] = useState("");
  const [error, setError] = useState("");
  const load = useCallback(() => {
    api.get("/admin/sag-fees", { params: period ? { period_id: period } : {} }).then((r) => setD(r.data)).catch((e) => setError(errMsg(e)));
  }, [period]);
  useEffect(() => { load(); }, [load]);
  const toggleSample = async (enabled) => {
    try { await api.put("/admin/sag-fees/sample-mode", { enabled }); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  if (error) return <p className="admin-card" role="alert" data-testid="sag-fees-forbidden">{error}</p>;
  if (!d) return <p aria-busy="true">Loading…</p>;
  return (
    <div className="space-y-6" data-testid="sag-fees-page">
      <header className="rounded-lg bg-navy p-6 text-white">
        <p className="text-xs uppercase tracking-[0.25em] text-gold" data-testid="sag-header">{d.header}</p>
        <h1 className="mt-2 font-serif text-3xl">SAG Processing Fees</h1>
        <p className="mt-1 text-sm text-white/80">Agreed {d.settings.rate_percent} processing fee payable to {d.payee}. Figures come from completed payment records only.</p>
      </header>
      {d.mode === "sample" && (
        <p className="rounded border-2 border-dashed border-gold bg-amber-50 p-3 text-sm font-semibold text-navy" role="status" data-testid="sag-sample-banner">
          SAMPLE / PREVIEW: calculated from TEST payments only. Nothing here is owed until live payments exist.</p>)}
      {d.can.toggle_sample && (
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={d.mode === "sample"} disabled={d.live_payments_exist}
          onChange={(e) => toggleSample(e.target.checked)} data-testid="sag-sample-toggle" /> SAMPLE mode {d.live_payments_exist && "(not available: live payments exist)"}</label>)}
      <FeeCards d={d} />
      <div className="grid gap-6 lg:grid-cols-2"><Schedule d={d} onChanged={load} /><Rules d={d} /></div>
      <PayPanel d={d} onChanged={load} />
      <Statement d={d} onPeriod={setPeriod} />
      <FeePayments d={d} onChanged={load} />
      <section className="admin-card text-sm" data-testid="sag-pending-items"><h2 className="text-lg text-navy">Pending confirmation with SAG</h2>
        <ul className="mt-2 list-disc pl-5">{d.pending_confirmation.map((x) => <li key={x}>{x}</li>)}</ul></section>
      <footer className="text-xs text-slate-600" data-testid="sag-cpay-footer">CPAY API connection: planned for a later phase. Status: not connected. Account {d.account_id}.</footer>
    </div>
  );
}
